import type { ShareChannel } from './share-channel';
import { withUtm } from './with-utm';

/** The `utm_source` for each channel. WhatsApp and Telegram are the names GA already files under social. */
const SOURCES: Record<ShareChannel, string> = {
    whatsapp: 'whatsapp',
    telegram: 'telegram',
    native: 'native_share',
    copy: 'copy_link'
};

/** `pageUrl`, tagged as having been shared through `channel`. */
export function sharedPageUrl(pageUrl: string, channel: ShareChannel, campaign: string, content?: string): string {
    return withUtm(pageUrl, { source: SOURCES[channel], medium: 'share', campaign, content });
}

/**
 * The messenger's own "send this" address for an already tagged URL.
 *
 * The title goes in the message rather than being left to the link preview, because a preview is
 * fetched later by the messenger and may not render at all on a slow connection.
 */
export function messengerShareHref(channel: 'whatsapp' | 'telegram', taggedUrl: string, title: string): string {
    if (channel === 'whatsapp') {
        return `https://wa.me/?text=${encodeURIComponent(`${title}\n${taggedUrl}`)}`;
    }

    return `https://t.me/share/url?url=${encodeURIComponent(taggedUrl)}&text=${encodeURIComponent(title)}`;
}
